import { resolveComponent as _resolveComponent, createVNode as _createVNode, KeepAlive as _KeepAlive, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["app-main", {'home_style':_ctx.viewing.includes(_ctx.key())}])
  }, [
    _createVNode(_Transition, {
      name: "fade-transform",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_KeepAlive, { include: _ctx.cachedViews }, [
          _createVNode(_component_router_view, { key: _ctx.key })
        ], 1032, ["include"]))
      ]),
      _: 1
    })
  ], 2))
}